import * as React from 'react';
import { Separator } from '@/components/ui/separator';

/**
 * MUI's `Stack divider` gave every rule a slot of its own, so the stack gap
 * lands on both sides of it. A `divide-y` border would collapse that to one gap.
 */
export const dividedChildren = (children: React.ReactNode): React.ReactNode[] =>
  React.Children.toArray(children).map((child, index) => (
    <React.Fragment key={React.isValidElement(child) && child.key != null ? child.key : index}>
      {index > 0 && <Separator />}
      {child}
    </React.Fragment>
  ));
